const zoomContainers = document.querySelectorAll('.media-zoom');

zoomContainers.forEach((container) => {
  const image = container.querySelector('.zoom-image');
  if (!image) return;

  let scale = 1;
  let pointX = 0;
  let pointY = 0;

  let startX = 0;
  let startY = 0;
  let touchStartX = 0;
  let touchStartY = 0;

  let hasMoved = false;

  const TAP_THRESHOLD = 10; // px

  /* DESKTOP CLICK ZOOM */
  container.addEventListener('click', (e) => {
    // if (window.innerWidth <= 768) return;

    if (scale === 1) {
      scale = 2;
      container.classList.add('is-zoomed');
      image.style.transformOrigin = 'center';
      image.style.transform = `scale(${scale})`;
    } else {
      scale = 1;
      pointX = 0;
      pointY = 0;
      container.classList.remove('is-zoomed');
      image.style.transform = `scale(1)`;
      image.style.transformOrigin = 'center';
    }
  });

  container.addEventListener('mousemove', (e) => {
    if (window.innerWidth <= 768) return;
    if (scale === 1) return;

    const rect = container.getBoundingClientRect();
    const x = ((e.clientX - rect.left) / rect.width) * 100;
    const y = ((e.clientY - rect.top) / rect.height) * 100;

    image.style.transformOrigin = `${x}% ${y}%`;
    image.style.transform = `scale(${scale})`;
  });

  container.addEventListener('mouseleave', () => {
    if (window.innerWidth <= 768) return;
    if (scale === 1) return;

    image.style.transformOrigin = 'center';
    image.style.transform = `scale(${scale})`;
  });

  /* MOBILE */
  container.addEventListener('touchstart', (e) => {
    if (window.innerWidth > 768) return;

    hasMoved = false;
    touchStartX = e.touches[0].clientX;
    touchStartY = e.touches[0].clientY;

    if (scale > 1) {
      // Zoomed in: prep for panning, lock the slider.
      startX = e.touches[0].clientX - pointX;
      startY = e.touches[0].clientY - pointY;
      if (mainSwiper) mainSwiper.allowTouchMove = false;
    } else {
      // Not zoomed: make sure slider can swipe freely.
      if (mainSwiper) mainSwiper.allowTouchMove = true;
    }
  }, { passive: true });

  container.addEventListener('touchmove', (e) => {
    if (window.innerWidth > 768) return;

    const dx = e.touches[0].clientX - touchStartX;
    const dy = e.touches[0].clientY - touchStartY;
    if (Math.abs(dx) > TAP_THRESHOLD || Math.abs(dy) > TAP_THRESHOLD) {
      hasMoved = true;
    }

    if (scale === 1) {
      // Not zoomed: don't intercept, let the swiper handle it natively.
      return;
    }

    // Zoomed: panning the image, block default scroll/swipe behavior.
    e.preventDefault();
    pointX = e.touches[0].clientX - startX;
    pointY = e.touches[0].clientY - startY;
    image.style.transform = `translate(${pointX}px, ${pointY}px) scale(${scale})`;
  }, { passive: false });

  container.addEventListener('touchend', () => {
    if (window.innerWidth > 768) return;

    if (mainSwiper) mainSwiper.allowTouchMove = true;

    if (hasMoved) {
      // It was a swipe (slide change) or a pan (while zoomed) — not a tap.
      return;
    }

    // Genuine tap: toggle zoom.
    if (scale === 1) {
      scale = 2;
      container.classList.add('is-zoomed');
      image.style.transform = `translate(0px, 0px) scale(${scale})`;
    } else {
      scale = 1;
      pointX = 0;
      pointY = 0;
      container.classList.remove('is-zoomed');
      image.style.transform = `translate(0px, 0px) scale(1)`;
    }
  });
});